export default __webpack_public_path__ + "static/media/back_card.b3ad9b20.png";